import { useCallback, useLayoutEffect, useRef } from 'react';

// Memory-only UI incarnation; compare the live service before each continuation.
// No credential/coordinate persistence, and no ownership inferred from responses.
export default function useAccountActionScope(service, resource = null) {
  const ref = useRef(null);
  const identity = service.authenticatedIdentity, owner = service.positionOwner, generation = service.backgroundIdentityGeneration;
  if (!ref.current || ref.current.service !== service || ref.current.identity !== identity || ref.current.owner !== owner || ref.current.generation !== generation || ref.current.resource !== resource) {
    ref.current = { service, identity, owner, generation, resource, active: true };
  }
  const scope = ref.current;
  useLayoutEffect(() => { scope.active = true; return () => { scope.active = false; }; }, [scope]);
  return useCallback(() => {
    const current = () => scope.active && ref.current === scope && service.authenticatedIdentity === identity && service.positionOwner === owner && service.backgroundIdentityGeneration === generation;
    return { current, assert: () => { if (!current()) throw Object.assign(new Error('Account or selected resource changed. Reopen this view.'), { code: 'REQUEST_ACCOUNT_CHANGED' }); } };
  }, [scope, service, identity, owner, generation]);
}
